let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9H1r6")).then(() => parcelRequire('cPrVi'));